import { GalleryConfig } from 'rangeConfig/@types';

const elvarliGalleryConfig: GalleryConfig = {
  default: [
    {
      sprs: [{ id: 'SPR-79562629' }]
    }
  ]
};

export default elvarliGalleryConfig;
